import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { removeCircleOutline, addCircleOutline } from 'ionicons/icons';

export interface QuantityStepperProps {
    quantity: number;
    onDecrement: () => void;
    onIncrement: () => void;
    'data-testid'?: string;
}

export const QuantityStepper: React.FC<QuantityStepperProps> = ({
    quantity,
    onDecrement,
    onIncrement,
    'data-testid': testId,
}) => (
    <div data-testid={testId} style={{ display: 'flex', alignItems: 'center' }}>
        <IonButton fill="clear" onClick={onDecrement}>
            <IonIcon icon={removeCircleOutline} />
        </IonButton>
        <span style={{ margin: '0 8px' }}>{quantity}</span>
        <IonButton fill="clear" onClick={onIncrement}>
            <IonIcon icon={addCircleOutline} />
        </IonButton>
    </div>
);

export default QuantityStepper;
